export default __webpack_public_path__ + "static/media/imported_workspace.842fb112.png";